import ShopBasicSettingsSection from './shop-basic-settings-section';

export default ShopBasicSettingsSection;
